import styled from 'styled-components'

export const _Panel = styled.a`
  -webkit-box-align: center;
  -ms-flex-align: center;
      align-items: center;
  color: #363636;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
      justify-content: flex-start;
  padding: 0.5em 0.75em;
`



// WEBPACK FOOTER //
// ./src/styled/panel.js